<template>
    <div>
        <el-table
            ref="cnam-caller-id-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="bundle_sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="getCnamRowForInformation(scope.row)"
                        name-field="display_name"
                    />
                </template>
            </el-table-column>

            <!-- Timestamps Column -->
            <el-table-column
                label="Timestamps"
                width="140"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Line Column -->
            <el-table-column
                label="Line"
                prop="campaign_id"
                width="220"
            >
                <template v-slot="scope">
                    <LineColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Phone Numbers Column -->
            <el-table-column
                label="Phone Numbers"
                prop="incoming_numbers_count"
                width="150"
            >
                <template v-slot="scope">
                    <CountColumn 
                        :value="scope.row.incoming_numbers_count"
                        :max-value="scope.row.campaign?.incoming_numbers_count || 0"
                    />
                </template>
            </el-table-column>

            <!-- Status Column -->
            <el-table-column
                label="Status"
                prop="bundle_status"
                width="120"
            >
                <template v-slot="scope">
                    <StatusColumn 
                        :row="getCnamRowForStatus(scope.row)"
                    />
                </template>
            </el-table-column>

            <!-- Failure Reason Column -->
            <el-table-column
                label="Failure reason"
                prop="bundle_failure_reason"
            >
                <template v-slot="scope">
                    <FailureReasonColumn 
                        :row="getCnamRowForFailureReason(scope.row)"
                    />
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Action"
                width="150"
            >
                <template v-slot="scope">
                    <div class="mt-1">
                        <el-button
                            type="danger"
                            size="mini"
                            class="btn-block"
                            @click="handleDeleteBundle(scope.row)"
                            :loading="loadingDeleteBundle.includes(scope.row.id)"
                        >
                            Delete
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import InformationColumn from '../columns/information-column'
import TimestampsColumn from '../columns/timestamps-column'
import StatusColumn from '../columns/status-column'
import FailureReasonColumn from '../columns/failure-reason-column'
import LineColumn from '../columns/line-column'
import CountColumn from '../columns/count-column'
import * as ComplianceBundleStatuses from '../../../constants/compliance-bundle-statuses'

export default {
    name: 'CnamCallerIdBundleTable',
    components: {
        InformationColumn,
        TimestampsColumn,
        StatusColumn,
        FailureReasonColumn,
        LineColumn,
        CountColumn,
    },
    props: {
        bundles: {
            type: Array,
            required: true,
        },
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getCnamRowForInformation(originalRow) {
            // Prepare the row for the InformationColumn
            return {
                ...originalRow,
                sid: originalRow.bundle_sid, // Map bundle_sid to sid
                friendly_name: originalRow.display_name, // Map display_name to friendly_name
            }
        },
        getCnamRowForStatus(originalRow) {
            // Prepare the row for the StatusColumn
            return {
                ...originalRow,
                status: originalRow.bundle_status, // Map bundle_status to status
                status_name: this.getStatusDisplayName(originalRow.bundle_status), // Format status name
            }
        },
        getCnamRowForFailureReason(originalRow) {
            // Prepare the row for the FailureReasonColumn
            return {
                ...originalRow,
                failure_reason: originalRow.bundle_failure_reason, // Map bundle_failure_reason to failure_reason
            }
        },
        getStatusDisplayName(status) {
            // Map status values to human-readable names
            const statusMap = {
                [ComplianceBundleStatuses.CNAM_STATUS_IN_REVIEW]: 'In Review',
                [ComplianceBundleStatuses.CNAM_STATUS_REJECTED]: 'Rejected',
                [ComplianceBundleStatuses.CNAM_STATUS_APPROVED]: 'Approved',
            }
            
            return statusMap[status] || 'Draft'
        },
        handleDeleteBundle(bundle) {
            this.$emit('delete-bundle', bundle)
        },
    },
}
</script>
